import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/ru';
import { MRT_Localization_EN } from 'material-react-table/locales/en';
import { MRT_Localization_RU } from 'material-react-table/locales/ru';
import { getAdminLocale } from './adminLocale';

export function getMrtLocalization() {
    return getAdminLocale() === 'en' ? MRT_Localization_EN : MRT_Localization_RU;
}

export function getDayjsLocale(): 'en' | 'ru' {
    return getAdminLocale() === 'en' ? 'en' : 'ru';
}

/** Call where pickers mount so calendar strings match admin locale. */
export function syncDayjsGlobalLocale() {
    dayjs.locale(getDayjsLocale());
}
